let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hYMkZ")).then(() => parcelRequire('cpvId'));